import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { CryptoRequest, HsmRegularKEKListDTO } from '../services/getHsmKeksRequestStatus'

export interface RegularKekHsmStatusState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  cryptoRequest: CryptoRequest | null
  kekList: HsmRegularKEKListDTO | null
}

const initialState: RegularKekHsmStatusState = {
  isLoading: false,
  error: null,
  httpStatus: null,
  cryptoRequest: null,
  kekList: null
}

const regularKekHsmStatusSlice = createSlice({
  name: 'regularKekHsmStatus',
  initialState,
  reducers: {
    regularKekHsmStatusLoadingAction: (state) => ({
      ...state,
      isLoading: true,
      error: null,
      httpStatus: null,
      cryptoRequest: null,
      kekList: null
    }),
    regularKekHsmStatusUpdateAction: (
      state,
      action: PayloadAction<{ cryptoRequest: CryptoRequest, httpStatus: number, kekList?: HsmRegularKEKListDTO }>
    ) => ({
      ...state,
      isLoading: false,
      error: null,
      httpStatus: action.payload.httpStatus,
      cryptoRequest: action.payload.cryptoRequest,
      kekList: action.payload.cryptoRequest.result ?? null
    }),
    regularKekHsmStatusErrorAction: (
      state,
      action: PayloadAction<{ errorMessage: string, httpStatus: number }>
    ) => ({
      ...state,
      isLoading: false,
      error: action.payload.errorMessage,
      httpStatus: action.payload.httpStatus,
      cryptoRequest: null,
      kekList: null
    })
  }
})

export const {
  regularKekHsmStatusLoadingAction,
  regularKekHsmStatusUpdateAction,
  regularKekHsmStatusErrorAction
} = regularKekHsmStatusSlice.actions

export default regularKekHsmStatusSlice.reducer
